export default {
  '测试结果详情':'測試結果詳情',
  '测试结果列表':'測試結果列表',
  '请输入学生姓名、学籍号':'請輸入學生姓名、學籍號',
  '同步组织测试':'同步組織測試',
  '批量删除':'批量刪除',
  '测评报告':'測評報告',
  '同步成功后，将覆盖展示最新的一次成绩':'同步成功後，將覆蓋展示最新的一次成績',
  
  '学年':'學年',
  '年级':'年級',
  '班级编号':'班級編號',
  '班级名称':'班級名稱',

  'BMI':'BMI',
  '身高(cm)':'身高(cm)',
  '体重(KG)':'體重(KG)',
  '肺活量(ml)':'肺活量(ml)',
  '50米跑(秒)':'50米跑(秒)',
  "800米跑(分秒)":"800米跑(分'秒)",
  "1000米跑(分秒)":"1000米跑(分'秒)",
  '坐位体前屈(cm)':'坐位體前屈(cm)',
  '一分钟跳绳(次)':'一分鐘跳繩(次)',
  '一分钟仰卧起坐':'一分鐘仰臥起坐',
  "50米X8往返跑(分秒)":"50米X8往返跑(分'秒)",
  '立定跳远(cm)':'立定跳遠(cm)',
  '引体向上(次)':'引體向上(次)',
  '免检原因':'免檢原因',

  '同步中':'同步中',
  '请选择组织测试计划':'請選擇組織測試計劃',
  '请选择记录':'請選擇記錄',
  '是否确认删除勾选学生测试结果？':'是否確認刪除勾選學生測試結果？',
  '删除后不可恢复，确认删除吗？':'刪除後不可恢復，確認刪除嗎？',
  '删除成功！':'刪除成功！',
  '是否确认删除学生{name}测试结果？':'是否確認刪除學生{name}測試結果？',
  
  '新增计划':'新增計劃',
  '详情':'詳情',
  '导入':'導入',
  '同步':'同步',
  '新增体质健康监测':'新增體質健康監測',
  '选择学年':'選擇學年',
  '同步组织测试':'同步組織測試',
  '同步成功后，将覆盖展示最新的一次成绩':'同步成功後，將覆蓋展示最新的一次成績',
  
  '参测人数':'參測人數',
  '平均分':'平均分',
  '优秀':'優秀',
  '良好':'良好',
  '及格':'及格',
  '不及格':'不及格',
  '操作账号':'操作賬號',
  '导入中，不允许重复同步':'導入中，不允許重複同步',
  '同步成功！':'同步成功！',
  '同步中，不允许重复导入':'同步中，不允許重複導入',
  '新建成功':'新建成功',
  '导入中，请勿删除':'導入中，請勿刪除',
  '同步中，请勿删除':'同步中，請勿刪除',
  '是否确认删除{acayearSemCodea}-{acayearSemCodeb} {acayearSemName}测试结果?':'是否確認刪除{acayearSemCodea}-{acayearSemCodeb} {acayearSemName}測試結果?',

  '学生体质健康测试报告单':'學生體質健康測試報告單',
  '姓名：':'姓名：',
  '班级：':'班級：',
  '学籍号：':'學籍號：',
  '性别：':'性別：',
  '学校：':'學校：',
  '单项指标':'單項指標',
  '年级平均':'年級平均',
  '体重指数（BMI）':'體重指數（BMI）',
  '（单位：千克/米²）':'（單位：千克/米²）',
  '肺活量':'肺活量',
  '（单位：毫升）':'（單位：毫升）',
  '50米跑':'50米跑',
  '（单位：秒）':'（單位：秒）',

  '坐位体前屈':'坐位體前屈',
  '（单位：厘米）':'（單位：厘米）',
  '一分钟跳绳':'一分鐘跳繩',
  '（单位：次）':'（單位：次）',
  '一分钟仰卧起坐(次)':'一分鐘仰臥起坐(次)',
  '50米×8往返跑':'50米×8往返跑',
  '（单位：分’秒）':'（單位：分’秒）',
  '立定跳远':'立定跳遠',
  '引体向上（男）':'引體向上（男）',
  '1000米跑（男）':'1000米跑（男）',
  '一分钟仰卧起坐（女）':'一分鐘仰臥起坐（女）',
  '800米跑（女）':'800米跑（女）',
  '标准分':'標準分',
  '加分指标':'加分指標',
  '1分钟跳绳':'1分鐘跳繩',

  '总分':'總分',
  '年级平均':'年級平均',
  '等级':'等級',
  '总评：':'總評：',
  '1、总分由标准分与附加分之和构成，满分为120分。标准分由各单项指标得分与权重乘积之和组成，满分为100分。附加分根据实测成绩确定，即对成绩超过100分的加分指标进行加分，满分为20分；小学的加分指标为1分钟跳绳，加分幅度为20分；初中、高中和大学的加分指标为男生引体向上和1000米跑，女生1分钟仰卧起坐和800米跑，各指标加分幅度均为10分。':'1、總分由標準分與附加分之和構成，滿分為120分。標準分由各單項指標得分與權重乘積之和組成，滿分為100分。附加分根據實測成績確定，即對成績超過100分的加分指標進行加分，滿分為20分；小學的加分指標為1分鐘跳繩，加分幅度為20分；初中、高中和大學的加分指標為男生引體向上和1000米跑，女生1分鐘仰臥起坐和800米跑，各指標加分幅度均為10分。',
  '等级判定':'2、等級判定：90.0分及以上為優秀，80.0～89.9分為良好，60.0～79.9分為及格，59.9分及以下為不及格。',

  '体质健康监测模板':'體質健康監測模板.xlsx',
  '测试成绩导出xlsx':'測試成績導出.xlsx',

  '选择组织测试':'選擇組織測試',
  '请选择组织测试':'請選擇組織測試',
  '同步方式':'同步方式',
  '覆盖原成绩':'覆蓋原成績',
  '择优更新':'擇優更新',
  '本次同步的项目将覆盖原有成绩':'本次同步的項目將覆蓋原有成績',
  '本次同步的项目与原有成绩择优后展示':'本次同步的項目與原有成績擇優後展示',
  '正在同步中，请勿关闭本页面':'正在同步中，請勿關閉本頁面',
  '同步完成':'同步完成',
  '同步完成但有异常数据':'同步完成但有異常數據',
  '取消同步':'取消同步',
  '确定要取消同步吗':'確定要取消同步嗎',
  '同步异常数据':'同步異常數據',
  '取消同步成功':'取消同步成功',
  '免考学生暂无报告单':'免考學生暫無報告單',
}